import { atomWithReset } from 'jotai/utils';

import { MenuType } from 'src/utils/constants/mainConstants';

export const detailWidgetsData = atomWithReset<{ [key in MenuType]: any }>({
  [MenuType.ATTENDANCE]: null,
  [MenuType.CAMPAIGN_BANNER]: null,
  [MenuType.CHECKLIST]: null,
  [MenuType.CREW_PULSE_TO_DO]: null,
  [MenuType.MY_INSTANT_LEARNING_PROGRESS_RATE]: null,

  [MenuType.MY_PORTFOLIO]: null,
  [MenuType.MY_PORTFOLIO_BOOKMARKED_LESSON]: null,
  [MenuType.MY_PORTFOLIO_LIKED_LESSON]: null,
  [MenuType.MY_PORTFOLIO_LIKED_INSTANT_LEARNING]: null,
  [MenuType.MY_PORTFOLIO_LIKED_SOCIAL_LEARNING]: null,
  // (ADDED)
  [MenuType.MY_PORTFOLIO_BOOKMARKED_MISSION]: null,
  [MenuType.MY_PORTFOLIO_ONLINE_DEGREE_QNA]: null,
  [MenuType.MY_PORTFOLIO_EXAM_QUESTION_QNA]: null,
  [MenuType.MY_PORTFOLIO_QUESTION_ISSUE_RESULT]: null,
  [MenuType.MY_PORTFOLIO_BADGE]: null,
  [MenuType.MY_PORTFOLIO_CERTIFICATE]: null,

  [MenuType.MY_REWARD]: null,
  [MenuType.MY_REWARD_RANKING]: null,
  [MenuType.MY_REWARD_STORE_RANKING]: null,
  [MenuType.MY_REWARD_LEVEL]: null,
  [MenuType.MY_REWARD_POINT]: null,

  [MenuType.QUICK_MENU]: null,
  [MenuType.RECOMMENDED_BY_ADMIN]: null,
  [MenuType.NOTICE]: null,
  [MenuType.RECENT_INSTANT_LEARNING]: null,

  [MenuType.PRODUCT_MANAGEMENT]: null,
  [MenuType.EXPIRATION_UNTIL_TODAY]: null,
  [MenuType.ONE_DAY_BEFORE_EXPIRATION]: null,
  [MenuType.WEEK_BEFORE_EXPIRATION]: null,

  [MenuType.RECENT_DEGREE]: null,
  [MenuType.MY_ONLINE_CLASS_WEEKLY_ACHIEVEMENT]: null,
  [MenuType.CREW_PULSE_ATTENDANCE_MANAGEMENT]: null,
  [MenuType.MY_COMMUNITY_ACTIVITY]: null,
  [MenuType.CREW_PULSE_TO_DO_CHECKBOX]: null,
  [MenuType.CREW_PULSE_TO_DO_COMPLETED]: null,
});
